/*
 * @Author: Admni
 * @Description: 
 * @Date: 2021-01-15 14:17:47
 * @LastEditTime: 2021-01-15 14:23:35
 */
import request from '@/utils/request'
// 获取报表
export function getReportList(params) {
    return request({
        url: '/d_r/',
        method: 'get',
        params
    })
}

// 处理列表
export function getSolveList(params) {
    return request({
        url: '/d_l/',
        method: 'get',
        params
    })
}

// 处理会话
export function toSolve(data) {
    return request({
        url: '/d_c/',
        method: 'post',
        data
    })
}